import { createAction, props } from '@ngrx/store';
import { PillReminderConfig } from '../networking/models/pill-reminder/responses/reminders-res';

export const getConfPillReminder = createAction(
  '[UI Pill Reminder Config] Set Pill Reminder Config',
  props<{ data: PillReminderConfig }>()
);